import {
  type GatsbyImageSchema,
  quoteWizardMockData
} from '@ecomm/shared-components'

export const QuizBannerImageMock: GatsbyImageSchema = {
  gatsbyImageData: {
    height: 1,
    images: {
      fallback: {
        src: 'test-img.png'
      },
      sources: [
        {
          srcSet: 'test-img.png 436w',
          type: 'image/webp'
        }
      ]
    },
    layout: 'fullWidth',
    width: 1
  },
  title: 'New Quiz Image'
}

export const staticQueryResponseMock = {
  image: {
    quoteWizardAsset: {
      originalWidth: 1326,
      originalHeight: 850,
      title: 'New Quiz Image',
      url: 'test-image.png',
      size: 302839,
      description: 'test-alt-text'
    }
  },
  quoteWizard: quoteWizardMockData.quoteWizard
}
